import _ from 'underscore';
import { useState, useEffect, useMemo } from 'react';

import { LOCATIONS_PER_PAGE } from '../utils/const';
import { LocationData, paginationConfigProps } from '../utils/types';

export const usePaginationConfig = (locations: Array<LocationData>): paginationConfigProps => {
  const [state, setState] = useState({ current: 0, total: 0 });

  useEffect(() => {
    if (!_.isEmpty(locations)) {
      setState({
        current: 1,
        total: Math.ceil(locations.length / LOCATIONS_PER_PAGE),
      });
    }
  }, [locations]);

  return useMemo(() => {
    const next = state.current + 1;
    let onNext: () => void = _.noop;
    if (next <= state.total) {
      onNext = () => setState({ ...state, current: next });
    }

    const previous = state.current - 1;
    let onPrevious: () => void = _.noop;
    if (previous > 0) {
      onPrevious = () => setState({ ...state, current: previous });
    }

    return ({
      current: state.current,
      total: state.total,
      onNext,
      onPrevious,
    });
  }, [state]);
};
